// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  /* padding: 1rem; */
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-heading {
  display: flex;
  align-items: center;
}

.book-filters {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.browse-header {
  font-family: "Roboto";
  color: #CC0000;
  font-weight: 700;
  margin: 0;
}

.browse-back-to-search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #CC0000;
  border-radius: 999px;
  color: #CC0000;
  background: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.browse-back-to-search::before {
  content: "→";
  font-size: 16px;
  line-height: 1;
}

.browse-back-to-search:hover,
.browse-back-to-search:focus {
  color: #ffffff;
  background: #CC0000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  text-decoration: none;
}

.subheading {
  display: flex;
  align-items: center;
  margin: 0;
  margin-top: 2rem;
  padding-bottom: 10px;
  color: #12394d;
}

.options {
  padding: 3rem;
  padding-top: 0;
  padding-bottom: 1rem;
  margin-right: 8px;
  display: flex;
  align-items: center;
}

.checkbox-label-browse {
  margin-right: 8px;
  font-weight: 600;
  max-width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.more-span {
  font-weight: bold;
  color: #b40000;
  cursor: pointer;
  display: flex;
  justify-content: end;
}

.line {
  margin-right: 0px;
  margin-top: 12px;
  height: 0px;
  max-width: 75px;
  background-color: #d9d9d9;
  border: 2px solid #cccccc;
}

.date-input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.from-to {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Collection Modal Styles */

.collection-modal-background {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.collection-modal {
  width: 450px;
  max-height: 70vh;
  overflow-y: auto;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #f0f0f0;
}


.new-heading {
  border-left: 2px solid #bdbdbd;
  font-size: 1.3em;
  font-weight: 500;
  margin: 0;
  margin-top: 2rem;
  padding-bottom: 10px;
  color: #12394d;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .new-heading {
    border-left: none;
    border-bottom: 2px solid #bdbdbd;
    padding-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/browse.rtl.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,gFAAgF;AAClF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;;AAGA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,gCAAgC;IAChC,oBAAoB;EACtB;AACF","sourcesContent":[".heading {\n  /* padding: 1rem; */\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filter-heading {\n  display: flex;\n  align-items: center;\n}\n\n.book-filters {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.browse-header {\n  font-family: \"Roboto\";\n  color: #CC0000;\n  font-weight: 700;\n  margin: 0;\n}\n\n.browse-back-to-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #CC0000;\n  border-radius: 999px;\n  color: #CC0000;\n  background: #ffffff;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-decoration: none;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.browse-back-to-search::before {\n  content: \"→\";\n  font-size: 16px;\n  line-height: 1;\n}\n\n.browse-back-to-search:hover,\n.browse-back-to-search:focus {\n  color: #ffffff;\n  background: #CC0000;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  text-decoration: none;\n}\n\n.subheading {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  margin-top: 2rem;\n  padding-bottom: 10px;\n  color: #12394d;\n}\n\n.options {\n  padding: 3rem;\n  padding-top: 0;\n  padding-bottom: 1rem;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-label-browse {\n  margin-right: 8px;\n  font-weight: 600;\n  max-width: 380px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.more-span {\n  font-weight: bold;\n  color: #b40000;\n  cursor: pointer;\n  display: flex;\n  justify-content: end;\n}\n\n.line {\n  margin-right: 0px;\n  margin-top: 12px;\n  height: 0px;\n  max-width: 75px;\n  background-color: #d9d9d9;\n  border: 2px solid #cccccc;\n}\n\n.date-input {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.from-to {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Collection Modal Styles */\n\n.collection-modal-background {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n\n.collection-modal {\n  width: 450px;\n  max-height: 70vh;\n  overflow-y: auto;\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  background-color: #f0f0f0;\n}\n\n\n.new-heading {\n  border-left: 2px solid #bdbdbd;\n  font-size: 1.3em;\n  font-weight: 500;\n  margin: 0;\n  margin-top: 2rem;\n  padding-bottom: 10px;\n  color: #12394d;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (max-width: 500px) {\n  .new-heading {\n    border-left: none;\n    border-bottom: 2px solid #bdbdbd;\n    padding-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
